import {
  Box,
  Container,
  Grid,
  Link,
  List,
  ListItem,
  ListItemButton,
  Typography
} from '@mui/material'
import { useTranslate } from 'react-admin'
import { useParams } from 'react-router-dom'

import { useEffect, useState } from 'react'
import { isNil, map } from 'lodash/fp'
import { getContent, getContents } from 'components/Util/functions'
import { ContentItem } from 'components/Util/types'

type PathParams = {
  category: string
  content: string
}

const Content: React.FC = (): JSX.Element => {
  const translation = useTranslate()
  const { category, content: contentId } = useParams<PathParams>()
  const [contents, setContents] = useState<ContentItem[] | undefined>(undefined)
  const [content, setContent] = useState<ContentItem | undefined>(undefined)
  useEffect(() => {
    if (!isNil(contents) || isNil(contentId)) return
    getContents(category).then((result: ContentItem[] | undefined) => {
      setContents(result)
    })
    getContent(contentId).then((result: ContentItem | undefined) => {
      setContent(result)
    })
  }, [])
  return isNil(category) || isNil(content) ? (
    <></>
  ) : (
    <Container>
      <Grid container>
        <Grid item xs={12} sx={{ marginTop: 3, marginBottom: 3, fontSize: 15 }}>
          <Link href={`/`}
            sx={{
              textDecoration: 'none'
            }}>{translation('resources.category.title')}</Link>
          <Typography
            sx={{
              display: 'inline',
              margin: 2
            }}>
            &gt;
          </Typography>
          <Link
            href={`/${category}`}
            sx={{
              textDecoration: 'none'
            }}>
            {category}
          </Link>
          <Typography
            sx={{
              display: 'inline',
              margin: 2
            }}>
            &gt;
          </Typography>
          <Link
            href={`/${category}/${content.id}`}
            sx={{
              textDecoration: 'none'
            }}>
            {content.title}
          </Link>
        </Grid>
        <Grid item xs={3}>
          <Typography
            variant="h6"
            component="h2"
            fontWeight="bold"
            sx={{ maxWidth: '100%', fontSize: 20 }}>
            {category} {translation('resources.content.menu')}
          </Typography>
          <List
            sx={{
              marginLeft: 0,
              paddingLeft: 0
            }}>
            {map((content: ContentItem) => {
              const { id, title } = content
              return (
                <ListItem
                  sx={{
                    marginLeft: 0,
                    paddingLeft: 0
                  }}>
                  <ListItemButton
                    href={`/${encodeURIComponent(category)}/${id}`}
                    sx={{
                      marginLeft: 0,
                      paddingLeft: 0,
                      maxWidth: '100%',
                      fontSize: 15
                    }}>
                    {title}
                  </ListItemButton>
                </ListItem>
              )
            })(contents)}
          </List>
        </Grid>
        <Grid item xs={9}>
          <Typography variant="h4" component="h2" fontWeight="bold">
            {content.title}
          </Typography>
          <Box
            sx={{
              whiteSpace: 'pre-line',
              fontWeight: 500,
              marginTop: 2,
            }}>
            {content.body}
          </Box>
        </Grid>
      </Grid>
    </Container>
  )
}

export default Content
